export default __webpack_public_path__ + "static/media/preforms.914f5cba.jpeg";